import React, {Suspense} from 'react';
import {Navigate, NavLink, Route, Routes} from "react-router-dom";
import SuspenseSpinner from "../../Utils/SuspenseSpinner";
import ConstructorRouter from "../Constructor/Constructor.Router";
import OutputForms from "../OutputForms/OutputForms";
import OutputFormsTemplates from "../OutputFormsTemplates/OutputFormsTemplates";
import ConstructorSidebarWrapper from "../Constructor/Constructor.Sidebar";
import MaterialsTable from "./MaterialsTable";
import {getPagesVisibility} from "../Privileges/PrivilegesSelectors";
import {useSelector} from "react-redux";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
    settings: {
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        gridTemplateRows: 'max-content 1fr',
        gridTemplateAreas: '"settings_tabs settings_tabs" "settings_sidebar settings_content"'
    },

    settingsContent: {
        gridArea: 'settings_content',
        padding: '.5em',
        backgroundColor: 'white'
    },

    settings_tabs: {
        gridArea: 'settings_tabs',
        padding: '.5em',
        backgroundColor: '#F3F3F7',
        borderBottom: '1px solid #E7E7EF',
        zIndex: '1',
        display: 'grid',
        gridAutoFlow: 'column',
        justifyContent: 'start',
        gridColumnGap: '.5em',
        boxShadow: '0 4px 8px -5px rgba(0, 0, 0, .65)'
    },

    settings_tab: {
        fontFamily: '"SF UI Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        textDecoration: 'none',
        fontSize: '.9em',
        color: 'rgb(66, 90, 112)',
        padding: '.5em 1em .5em 1em',
        borderRadius: '.5em'
    },

    settings_tab_active: {
        color: 'rgb(16, 112, 202)',
        backgroundColor: 'rgba(16, 112, 202, 0.09) !important'
    }

})

export default function Materials() {
    const classes = useStyles();
    const [sidebarVisible, setSidebarVisible] = React.useState(true)
    const privileges = useSelector(state => state.login.privileges)
    const pagesVisibility = getPagesVisibility(privileges);


    function getDefaultNavigation() {
        if (pagesVisibility.ARCHIVE) return "archive";
        if (pagesVisibility.OUTPUT_FORMS) return "outputForms";
        if (pagesVisibility.TEMPLATES) return "templates";
        if (pagesVisibility.CONSTRUCTORS) return "constructor/*";
    }

    const ConstructorsSidebarWrapper = React.useMemo(() => (
            <Routes>
                <Route path="constructor/*" element={
                        <ConstructorSidebarWrapper/>
                }/>
            </Routes>
    ), [])

    return (
        <div className={classes.settings}>
            <div className={classes.settings_tabs}>
                {pagesVisibility.ARCHIVE && <NavLink to="archive" className={classes.settings_tab} activeClassName={classes.settings_tab_active} onClick={() => setSidebarVisible(false)}>Архив</NavLink>}
                {pagesVisibility.OUTPUT_FORMS && <NavLink to="outputForms" className={classes.settings_tab} activeClassName={classes.settings_tab_active} onClick={() => setSidebarVisible(false)}>Выходные формы</NavLink>}
                {pagesVisibility.TEMPLATES && <NavLink to="templates" className={classes.settings_tab} activeClassName={classes.settings_tab_active} onClick={() => setSidebarVisible(false)}>Шаблоны выходных форм</NavLink>}
                {pagesVisibility.CONSTRUCTORS && <NavLink to="constructor" className={classes.settings_tab} activeClassName={classes.settings_tab_active} onClick={() => setSidebarVisible(true)}>Конструкторы</NavLink>}
            </div>
            {sidebarVisible ? ConstructorsSidebarWrapper : ""}
            <div className="settings-content" style={{overflow: "visible", "minWidth": "90vw"}}>
                <Suspense fallback={<SuspenseSpinner/>}>
                    <Routes>
                        {pagesVisibility.TEMPLATES && <Route path="templates" element={<OutputFormsTemplates />} />}
                        {pagesVisibility.CONSTRUCTORS && <Route path="constructor/*" element={<ConstructorRouter />}/>}
                        {pagesVisibility.OUTPUT_FORMS && <Route path="outputForms" element={<OutputForms />} />}
                        {pagesVisibility.ARCHIVE && <Route path="archive" element={<MaterialsTable/>} />}
                        {<Route path="*" element={<Navigate to={getDefaultNavigation()} />} />}
                    </Routes>
                </Suspense>
            </div>
        </div>
    )
}


